module.exports = __webpack_public_path__ + "static/img/data-center-2.ab9e8c10.png";